import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import type { SellerFreightProvider } from '../freight/freight-types';

export const useSellerFreightProvider = (
  sellerFreightProviderId: number | string | null | undefined,
): SellerFreightProvider | undefined => {
  const sellerFreightProviders = useSelector(Global.selectSellerFreightProviders) as SellerFreightProvider[];

  return useMemo(() => {
    if (sellerFreightProviderId === null || sellerFreightProviderId === undefined) {
      return undefined;
    }
    const sellerFreightProviderIdNumber = Number.parseInt(String(sellerFreightProviderId), 10);
    return sellerFreightProviders.find((sellerFreightProvider) => {
      return sellerFreightProvider.sellerFreightProviderId === sellerFreightProviderIdNumber;
    });
  }, [sellerFreightProviders, sellerFreightProviderId]);
};
